import AnalyticsNav from "@assets:analytics_nav.svg";
import Bot from "@assets:bot.svg";
import BotNav from "@assets:bot_nav.svg";
import BotSearch from "@assets:bot_search.svg";
import ChatMessage from "@assets:chat_message.svg";
import CheckIcon from "@assets:check.svg";
import CopyIcon from "@assets:copy-alt.svg";
import DislikeIcon from "@assets:dislike.svg";
import DocTranslate from "@assets:doc_translate.svg";
import DocsNav from "@assets:docs_nav.svg";
import DocumentIcon from "@assets:document.svg";
import LikeIcon from "@assets:like.svg";
import Lock from "@assets:lock.svg";
import NemoLogo from "@assets:logo.svg";
import InnovumLogo from "@assets:logo_innovum.svg";
import Search from "@assets:search.svg";
import SendMessage from "@assets:send_message.svg";
import UploadIcon from "@assets:upload.svg";
import URLIcon from "@assets:url.svg";
import WriteIcon from "@assets:write.svg";
import { SvgIcon, SxProps } from "@mui/material";
import { ElementType } from "react";
import { BiDislike, BiLike } from "react-icons/bi";
import { FaStar } from "react-icons/fa";
import { FaCopy, FaDownload, FaRegCircleCheck } from "react-icons/fa6";
import { IoMdCheckmarkCircle } from "react-icons/io";
import { LuAudioLines } from "react-icons/lu";
import { MdAccessTime, MdCancel, MdOutlineCancel } from "react-icons/md";

const Icons = {
  nemoIcon: NemoLogo,
  lockIcon: Lock,
  botIcon: Bot,
  innovumIcon: InnovumLogo,
  chatMessageIcon: ChatMessage,
  dislikeIcon: BiDislike,
  likeIcon: BiLike,
  starIcon: FaStar,
  searchIcon: Search,
  botNav: BotNav,
  docsNav: DocsNav,
  analyticsNav: AnalyticsNav,
  botSearch: BotSearch,
  sendMessage: SendMessage,
  checkIcon: CheckIcon,
  copyIcon: CopyIcon,
  uploadIcon: UploadIcon,
  documentIcon: DocumentIcon,
  urlIcon: URLIcon,
  writeIcon: WriteIcon,
  dislike2XIcon: DislikeIcon,
  like2XIcon: LikeIcon,
  docTranslate: DocTranslate,
  audio: LuAudioLines,
  time: MdAccessTime,
  checkMarkCircle: IoMdCheckmarkCircle,
  cancel: MdCancel,
  circleCheck: FaRegCircleCheck,
  outlineCancel: MdOutlineCancel,
  download: FaDownload,
  copiedIcon: FaCopy,
};

interface SVGInternalIconProps {
  sx?: SxProps;
  icon: keyof typeof Icons;
}

export const SVGInternalIcon = ({ sx, icon }: SVGInternalIconProps) => {
  const Icon = Icons[icon] as ElementType;
  return (
    <SvgIcon
      inheritViewBox
      sx={{
        ...sx,
      }}
      component={Icon}
    />
  );
};
